import List from "./list/Certificates";

export default { List };
